module.exports = __webpack_public_path__ + "assets/img/CTA-decisionV2.318d2f82.jpg";